import { render, staticRenderFns } from "./store-admin.vue?vue&type=template&id=79cbcf53&scoped=true&"
import script from "./store-admin.vue?vue&type=script&lang=js&"
export * from "./store-admin.vue?vue&type=script&lang=js&"
import style0 from "./store-admin.vue?vue&type=style&index=0&id=79cbcf53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cbcf53",
  null
  
)

export default component.exports